<template>
  <v-container fluid class="admin-tools-page pa-4">
    <div class="admin-header">
      <div>
        <div class="page-title">Admin Tools</div>
        <div class="page-subtitle">
          Manage users, products, invoices, and business settings
        </div>
      </div>
    </div>

    <v-row dense>
      <v-col
        cols="12"
        md="6"
        lg="4"
        v-if="checkRightStatus(27) || checkRightStatus(54)"
      >
        <v-card outlined class="tool-section-card">
          <div class="section-header">
            <div class="section-icon user-icon">
              <v-icon>mdi-account-cog-outline</v-icon>
            </div>

            <div>
              <div class="section-title">User</div>
              <div class="section-subtitle">Create and manage employees</div>
            </div>
          </div>

          <v-card-text class="pa-3">
            <div
              v-if="checkRightStatus(27)"
              class="tool-row"
              @click="$router.push('/user/create')"
            >
              <v-avatar tile size="42" class="tool-avatar">
                <v-img src="@/assets/AdminTools/man.png"></v-img>
              </v-avatar>

              <div class="tool-content">
                <div class="tool-title">New User</div>
                <div class="tool-subtitle">Add a new employee account</div>
              </div>

              <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
            </div>

            <div
              v-if="checkRightStatus(54)"
              class="tool-row"
              @click="$router.push('/user/list')"
            >
              <v-avatar tile size="42" class="tool-avatar">
                <v-img src="@/assets/AdminTools/client.png"></v-img>
              </v-avatar>

              <div class="tool-content">
                <div class="tool-title">Existing User</div>
                <div class="tool-subtitle">View and update user accounts</div>
              </div>

              <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4" v-if="checkRightStatus(55)">
        <v-card outlined class="tool-section-card">
          <div class="section-header">
            <div class="section-icon invoice-icon">
              <v-icon>mdi-receipt-text-edit-outline</v-icon>
            </div>

            <div>
              <div class="section-title">Invoice</div>
              <div class="section-subtitle">Invoice maintenance tools</div>
            </div>
          </div>

          <v-card-text class="pa-3">
            <div class="tool-row" @click="$router.push('/invoice/adjustCost')">
              <v-avatar tile size="42" class="tool-avatar">
                <v-img src="@/assets/AdminTools/budget.png"></v-img>
              </v-avatar>

              <div class="tool-content">
                <div class="tool-title">Adjust Cost Price</div>
                <div class="tool-subtitle">
                  Fix product cost on invoice records
                </div>
              </div>

              <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="6"
        lg="4"
        v-if="checkRightStatus(52) || checkRightStatus(53)"
      >
        <v-card outlined class="tool-section-card">
          <div class="section-header">
            <div class="section-icon product-icon">
              <v-icon>mdi-package-variant-closed</v-icon>
            </div>

            <div>
              <div class="section-title">Product</div>
              <div class="section-subtitle">
                Merge duplicate products and categories
              </div>
            </div>
          </div>

          <v-card-text class="pa-3">
            <div class="merge-wrap">
              <ProductMerge v-if="checkRightStatus(52)" />
              <CategoryMerge v-if="checkRightStatus(53)" />
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4" v-if="checkRightStatus(26)">
        <v-card outlined class="tool-section-card">
          <div class="section-header">
            <div class="section-icon business-icon">
              <v-icon>mdi-store-cog-outline</v-icon>
            </div>

            <div>
              <div class="section-title">Business</div>
              <div class="section-subtitle">Business setup and preferences</div>
            </div>
          </div>

          <v-card-text class="pa-3">
            <div class="tool-row" @click="$router.push('/setting')">
              <v-avatar tile size="42" class="tool-avatar">
                <v-img src="@/assets/AdminTools/gear.png"></v-img>
              </v-avatar>

              <div class="tool-content">
                <div class="tool-title">Setting</div>
                <div class="tool-subtitle">Manage business configuration</div>
              </div>

              <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4" v-if="checkRightStatus(26)">
        <v-card outlined class="tool-section-card">
          <div class="section-header">
            <div class="section-icon image-icon">
              <v-icon>mdi-image-size-select-large</v-icon>
            </div>

            <div>
              <div class="section-title">Images</div>
              <div class="section-subtitle">Speed up product image loading</div>
            </div>
          </div>

          <v-card-text class="pa-3">
            <div class="tool-row" @click="openImageOptimizer">
              <v-avatar tile size="42" class="tool-avatar">
                <v-icon color="primary">mdi-image-sync-outline</v-icon>
              </v-avatar>

              <div class="tool-content">
                <div class="tool-title">Optimize Images</div>
                <div class="tool-subtitle">
                  Create thumbnails for old product images
                </div>
              </div>

              <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="imageOptimizeDialog" max-width="560px" persistent>
      <v-card class="optimize-dialog-card">
        <div class="dialog-header">
          <div>
            <div class="dialog-title">Optimize Product Images</div>
            <div class="dialog-subtitle">
              Create small thumbnail images for faster catalog loading.
            </div>
          </div>

          <v-btn
            icon
            small
            :disabled="imageOptimizeLoading"
            @click="imageOptimizeDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-4">
          <div class="optimize-summary">
            <div class="summary-box">
              <div class="summary-label">Remaining</div>
              <div class="summary-value">{{ imageOptimizeRemaining }}</div>
            </div>

            <div class="summary-box">
              <div class="summary-label">Processed</div>
              <div class="summary-value">{{ imageOptimizeProcessed }}</div>
            </div>

            <div class="summary-box">
              <div class="summary-label">Failed</div>
              <div class="summary-value">{{ imageOptimizeFailed }}</div>
            </div>
          </div>

          <v-progress-linear
            v-if="imageOptimizeLoading"
            class="mt-4"
            indeterminate
            color="primary"
          />

          <div class="optimize-text mt-4">
            This will process product images in small batches. You can close
            this dialog after it finishes.
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions class="dialog-actions">
          <v-spacer />
          <v-btn
            text
            :disabled="imageOptimizeLoading"
            @click="imageOptimizeDialog = false"
          >
            Close
          </v-btn>

          <v-btn
            color="primary"
            rounded
            dark
            :loading="imageOptimizeLoading"
            @click="createThumbnails"
          >
            Start Optimize
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import invoiceService from "@/modules/Invoice/service.js";
import ProductMerge from "@/modules/Product/components/Merge.vue";
import CategoryMerge from "@/modules/Product/Category/components/Merge.vue";
import imageService from "@/modules/Product/service.js";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      imageOptimizeDialog: false,
      imageOptimizeLoading: false,
      imageOptimizeRemaining: 0,
      imageOptimizeProcessed: 0,
      imageOptimizeFailed: 0,
    };
  },
  components: {
    ProductMerge,
    CategoryMerge,
  },

  computed: {
    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),
  },

  methods: {
    ...mapActions("layout", ["setOpenRestockSerial"]),
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async openImageOptimizer() {
      this.imageOptimizeDialog = true;
      this.imageOptimizeProcessed = 0;
      this.imageOptimizeFailed = 0;
      await this.checkThumbnailStatus();
    },

    async checkThumbnailStatus() {
      const response = await imageService.thumbnailStatus();
      this.imageOptimizeRemaining = Number(response.remaining || 0);
    },

    async createThumbnails() {
      this.imageOptimizeLoading = true;
      this.imageOptimizeProcessed = 0;
      this.imageOptimizeFailed = 0;

      try {
        await this.checkThumbnailStatus();

        while (this.imageOptimizeRemaining > 0) {
          const response = await imageService.processThumbnails(25);

          this.imageOptimizeProcessed += Number(response.processed || 0);
          this.imageOptimizeFailed += Number(response.failed || 0);
          this.imageOptimizeRemaining = Number(response.remaining || 0);

          if (!response.processed && !response.failed) {
            this.$swal(
              "Images",
              "No more processable images found.",
              "warning"
            );
            return;
          }

          await this.sleep(500);
        }

        this.$swal("Images", "Image optimization completed.", "success");
      } catch (error) {
        console.error("image optimize failed", error);
        this.$swal("Images", "Image optimization stopped.", "error");
      } finally {
        this.imageOptimizeLoading = false;
      }
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async migration() {
      const mig = await invoiceService.migration();
      console.log("migration", mig);
    },
  },
};
</script>

<style scoped>
.admin-tools-page {
  background: #f8fafc;
  min-height: 100%;
}

.admin-header {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 18px;
  margin-bottom: 16px;
}

.page-title {
  font-size: 24px;
  font-weight: 900;
  color: #0f172a;
  line-height: 1.1;
}

.page-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 5px;
}

.tool-section-card {
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
  height: 100%;
}

.section-header {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-icon {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-icon .v-icon {
  color: #ffffff;
}

.user-icon {
  background: #2563eb;
}

.invoice-icon {
  background: #16a34a;
}

.product-icon {
  background: #f97316;
}

.business-icon {
  background: #7c3aed;
}

.section-title {
  font-size: 18px;
  font-weight: 900;
  color: #0f172a;
}

.section-subtitle {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.tool-row {
  border-radius: 16px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}

.tool-row:hover {
  background: #f8fafc;
  transform: translateY(-1px);
}

.tool-avatar {
  background: #f1f5f9;
  border-radius: 12px;
}

.tool-content {
  flex: 1;
  min-width: 0;
}

.tool-title {
  font-size: 15px;
  font-weight: 900;
  color: #0f172a;
}

.tool-subtitle {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.merge-wrap {
  display: grid;
  gap: 10px;
}

.image-icon {
  background: #0891b2;
}

.optimize-dialog-card {
  border-radius: 20px;
  overflow: hidden;
}

.dialog-header {
  padding: 18px 20px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.dialog-title {
  font-size: 20px;
  font-weight: 900;
  color: #0f172a;
}

.dialog-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.dialog-actions {
  padding: 12px 16px;
}

.optimize-summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.summary-box {
  background: #f8fafc;
  border-radius: 16px;
  padding: 14px;
}

.summary-label {
  font-size: 12px;
  color: #64748b;
}

.summary-value {
  font-size: 22px;
  font-weight: 900;
  color: #0f172a;
  margin-top: 4px;
}

.optimize-text {
  font-size: 13px;
  color: #64748b;
}

@media (max-width: 600px) {
  .admin-tools-page {
    padding: 10px !important;
  }

  .admin-header {
    padding: 14px;
    border-radius: 16px;
  }

  .page-title {
    font-size: 21px;
  }

  .tool-section-card {
    border-radius: 16px;
  }

  .section-header {
    padding: 14px;
  }

  .tool-row {
    padding: 10px;
  }
}
</style>